import Grid3 from '@shared/components/Grid3';
import { H2, H3 } from '@shared/components/Heading';
import Paragraph from '@shared/components/Paragraph';
import { FC, memo } from 'react';

import { SectionDark3 } from '../../components/ColoredSection';

const About: FC = () => (
  <SectionDark3>
    <H2>Worum geht es im Training?</H2>

    <Grid3 spacing='2rem'>
      <Grid3.Item>
        <H3>Trainings-Arbeit</H3>
        <Paragraph>
          Der Fokus liegt auf der eigenen Entspannung, Balance, Achtsamkeit, Atmung, Gefühl und
          Struktur. Das Training erfolgt langsam, um eine tiefere Verarbeitung der Informationen zu
          ermöglichen. Gedanken an Zweikampf sind hier störend und unerwünscht. Stattdessen arbeiten
          die Trainingspartner gemeinsam an ihrer persönlichen Weiterentwicklung.
        </Paragraph>
      </Grid3.Item>
      <Grid3.Item>
        <H3>Meister-Arbeit</H3>
        <Paragraph>
          Die Partner widmen sich der feinsten Arbeit und versuchen ihre Bewegung weit jenseits der
          Vorstellungskraft zu optimieren. Diese Arbeit hilft bei der eigenen emotionalen
          Durcharbeitung und Charakter-Entwicklung. Sie erfordert ein Verständnis vom Leben im Jetzt
          und großen Fortschritt in den Grundlagen der Trainings-Arbeit.
        </Paragraph>
      </Grid3.Item>
      <Grid3.Item>
        <H3>Kampf-Arbeit</H3>
        <Paragraph>
          Hier geht es um Techniken und Konzepte für die Selbstverteidigung. Dabei stehen Schläge,
          Nervendruck- und Vitaltechniken, Würfe und Hebel im Mittelpunkt. Diese Arbeit baut auf der
          Trainings-Arbeit auf und wird erst nach entsprechendem Fortschritt in den grundlegenden
          Übungen begonnen.
        </Paragraph>
      </Grid3.Item>
    </Grid3>
  </SectionDark3>
);

export default memo(About);
